<template lang="pug">
  .lessons-calendar
    .d-flex.mb-5.ma-4.align-center
      v-btn(
        depressed
        rounded
        outlined
        :text="!isToday"
        :color="(isToday && 'secondary') || 'default'"
        @click="setToday"
      ) Cегодня
      v-btn(small icon @click="prev")
        v-icon(small) mdi-arrow-left
      .text-subtitle-1.d-inline-block {{ focus | dp('yyyy MMM') }}
      v-btn(small icon @click="next")
        v-icon(small) mdi-arrow-right
      v-spacer
      v-btn-toggle(
        v-model="type"
        mandatory
        rounded
        dense
      )
        v-btn(
          value="week"
          outlined
        ) Неделя
        v-btn(
          value="month"
          outlined
        ) Месяц

    v-row.ml-2
      v-col(cols="12" md="6" lg="3")
        select-course(
          v-model="course"
          :serverDataAttrs="params"
        )

    .ma-4.mt-0 * выберите день и нажмите на нужный, чтобы составить расписание
    v-skeleton-loader(v-if="loading" type="table")
    v-calendar.v-calendar.min-height-500.pr-0(
      v-else
      ref="calendar"
      v-model="focus"
      :events="lessons"
      :type="type"
      event-name="courseTitle"
      event-start="date_start"
      event-end="date_end"
      :weekdays="WEEKDAYS"
      first-time="00:00"
      :interval-count="24"
      :event-more="false"
      :event-color="getEventColor"
      @click:event="showEvent"
      @click:date="viewDay"
      @click:more="viewDay"
    )
    v-menu(
      v-if="selectedEvent"
      v-model="selectedOpen"
      :close-on-content-click="false"
      :activator="selectedElement"
      offset-y
      max-width="800px"
      min-width="300px"
    )
      v-card(
        flat
      )
        v-toolbar(
          :color="selectedEvent.color"
        )
          v-icon(
            v-if="selectedEvent.type === $conf.CONFERENCE_SOURCE.telegram"
            color="white"
          ) $telegram
          v-icon(v-else color="white") mdi-clipboard-outline
          //- :to=`{
          //-     name: 'EducationCourseUnitList',
          //-     params: {
          //-       courseId: selectedCourse,
          //-       unitId: selectedEvent.course_unit_id,
          //-     },
          //-   }`
          v-btn(Meeting
            text
            color="white"
          ).ml-3 {{ selectedEvent.courseTitle }}
          v-spacer
          v-menu()
            template(#activator="{ on }")
              v-btn(v-on="on" icon color="white")
                v-icon mdi-dots-vertical
            v-list.pa-2.secondary
              v-list-item
                v-btn(
                  v-if="selectedEvent.type === $conf.CONFERENCE_SOURCE.telegram"
                  color="white"
                  block
                  outlined
                  @click="open(selectedEvent)"
                ) Изменить
                  v-icon(right color="info") mdi-pencil
              v-list-item
                v-btn(
                  color="white"
                  block
                  outlined
                  @click="deleteModule(selectedEvent.id, selectedEvent.type)"
                ) Удалить
                  v-icon(right color="error") mdi-delete
        v-card-text
          p {{ selectedEvent.description }}
          p {{ $conf.CONFERENCE_SOURCE_LABEL[selectedEvent.type] }}
          .d-flex
            span Начало
            v-spacer
            strong  {{ selectedEvent.date_start | dp('HH:mm') }}
          .d-flex
            span Завершение
            v-spacer
            strong  {{ selectedEvent.date_end | dp('HH:mm') }}
          v-alert.my-2(
            v-if="selectedEvent.isForbidden"
            :color="selectedEvent.color"
            text
          )
            v-icon(:color="selectedEvent.color").mr-2 mdi-alert
            span Урок будет доступен после прохождения предыдущего
        v-card-actions
          v-btn(
            text
            @click="selectedOpen = false"
          ) Закрыть
          v-btn(
            v-if="selectedEvent.type === $conf.CONFERENCE_SOURCE.telegram"
            depressed
            :color="selectedEvent.color"
            :disabled="!selectedEvent.conference || selectedEvent.isForbidden"
            target="_blank"
            dark
            :href="selectedEvent.conference ? selectedEvent.conference.group.invite_link : ''"
          ) Перейти
</template>

<script>
import {
  format,
  getMonth,
  startOfMonth,
  endOfMonth,
  isBefore,
  isAfter,
  startOfDay,
  endOfDay,
} from 'date-fns';

import SelectCourse from '@/components/InputFields/course/SelectCourse.vue';
import ConferenceFormTelegram from './Conference/ConferenceFormTelegram.vue';

const today = format(new Date(), 'yyyy-MM-dd');

export default {
  name: 'LessonsCalendar',
  components: {
    SelectCourse,
  },
  props: {
    selectedCourse: { type: Number, default: null },
  },
  data() {
    return {
      course: null,
      focus: null,
      lessons: [],
      WEEKDAYS: [1, 2, 3, 4, 5, 6, 0],
      loading: false,

      selectedEvent: null,
      selectedElement: null,
      selectedOpen: false,
      type: 'week',

      COLORS: ['#464555', '#EB5D63', '#ABA9BB', '#777586', '#AD2234'],
    };
  },
  computed: {
    params() {
      const isStudent = this.$user.studentMode || this.$user.isStudent;
      return {
        query: {
          ...isStudent ? { 'search[trained]': this.$user.data.id } : { 'search[author_or_teacher]': this.$user.data.id },
        },
      };
    },
    isToday() {
      return this.focus === today;
    },
    startMonth() {
      if (!this.focus) return null;
      return startOfMonth(new Date(this.focus));
    },
    endMonth() {
      if (!this.focus) return null;
      return endOfMonth(new Date(this.focus));
    },
  },
  watch: {
    course() {
      this.getSchedule();
    },
    selectedCourse() {
      this.init();
    },
    focus(oldval, newval) {
      if (oldval && newval) {
        const oldmonth = getMonth(new Date(oldval));
        const newmonth = getMonth(new Date(newval));
        if (oldmonth !== newmonth) {
          this.init();
          this.$emit('open-day', { date: null, lessons: [] });
        }
      }
    },
  },
  created() {
    this.setToday();
    this.init();
  },
  methods: {
    deleteModule(id, type) {
      const service = type === this.$conf.CONFERENCE_SOURCE.telegram ? 'telegram' : 'schedule';
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Удаление конференции',
        message: 'Подтвердите удаление конференции',
        method: async () => {
          await this.$api[service].conferenceDelete(id);
          const idx = this.lessons.findIndex((i) => i.id === id);
          this.lessons.splice(idx, 1);
          this.$modals.close();
          this.$toasted.success('Конференция успешно удалена');
        },
      });
    },
    open(item) {
      this.$modals.show('generic-controller', {
        component: ConferenceFormTelegram,
        title: 'Редактирование конференции',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          successCallback: ({ data }) => {
            this.$modals.close();
            this.$toasted.success('Успешно');
            item.date_start = this.$dp.dateprintDefault(data.data.date_start);
            item.date_end = this.$dp.dateprintDefault(data.data.date_end);
            item.courseTitle = data.data.title;
          },
          id: item.id,
          data: {
            title: item.courseTitle,
            date: item.date_start.split(' ')[0],
            duration: {
              start: item.date_start.split(' ')[1],
              end: item.date_end.split(' ')[1],
            },
          },
          isEdit: true,
        },
      });
    },

    async init() {
      this.loading = true;
      await this.getSchedule();
      this.loading = false;
    },
    async getSchedule() {
      const query = {
        'per-page': -1,
        'search[from_date]': this.startMonth,
        'search[to_date]': this.endMonth,
        'search[course_id]': this.course && this.course.id,
        ...this.$user.isTeacher ? {
          'search[teacher_id]': this.$user.studentMode ? null : this.$user.data.teacher_id,
          'search[im_learning]': this.$user.studentMode || null,
          'search[me_and_open]': this.$user.studentMode || null,
        } : {
          'search[me_and_open]': true,
        },
        expand: 'users,groups,prior_records,courses',
      };
      const { items } = await this.$api.telegram.conferenceIndex(query);
      const jazz = await this.$api.schedule.index({ ...query, expand: 'lesson,meeting' });

      const { COLORS } = this;

      this.lessons = [
        ...jazz.data.data.map((i) => ({
          id: i.id,
          type: this.$conf.CONFERENCE_SOURCE.jazz,
          description: i.lesson.description,
          isForbidden: i.isForbidden,
          color: COLORS[1],
          courseTitle: i.lesson.name,
          date_start: this.$dp.dateprintDefault(i.date_start),
          date_end: this.$dp.dateprintDefault(i.date_end),
        })),
        ...items.map((i) => ({
          id: i.id,
          type: this.$conf.CONFERENCE_SOURCE.telegram,
          conference: i.conference,
          courseTitle: i.title,
          color: COLORS[0],
          date_start: this.$dp.dateprintDefault(i.date_start),
          date_end: this.$dp.dateprintDefault(i.date_end),
        })),
      ];
    },
    dailyLessons(day) {
      const dDay = new Date(day);
      const startDay = startOfDay(dDay);
      const endDay = endOfDay(dDay);

      return this.lessons.filter(
        (i) => (
          isAfter(new Date(i.date_start), startDay)
          && isBefore(new Date(i.date_end), endDay)
        ),
      );
    },
    routeToLessonList() {
      return {
        name: 'EducationLesson',
        params: {
          courseId: this.selectedCourse,
          unitId: this.selectedEvent.course_unit_id,
          lessonId: this.selectedEvent.lesson_id,
        },
      };
    },
    viewDay({ date }) {
      this.focus = date;
      this.openDay();
    },
    getEventColor(event) {
      return event.color;
    },
    /*
    * Replace or push lesson to reactive lessons array
    */
    pushLesson(lesson) {
      if (this.lessons.find((i) => i.id === lesson.id)) {
        this.lessons = this.lessons.map(
          (i) => (i.id === lesson.id ? lesson : i),
        );
      } else this.lessons.push(lesson.data);

      this.openDay();
    },
    openDay() {
      if (this.focus) {
        const lessons = this.dailyLessons(this.focus);
        this.$emit('open-day', { date: this.focus, lessons });
      }
    },
    removeLesson(lessonId) {
      this.lessons = this.lessons.filter((i) => i !== lessonId);
    },
    setToday() {
      this.focus = today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-calendar-weekly__week {
  min-height: auto;
}

.v-calendar {
  transform: scale(1.001);
}
</style>
